import { acceptHMRUpdate, defineStore } from "pinia";
import axios from "axios";
import { LoyaltyUser, emptyLoyaltyUser } from "@/models/loyaltyUser";
import { LoyaltyTier } from "@/models/loyaltyTier";
import { LoyaltyReward } from "@/models/loyaltyReward";
import { Subscription } from "@/models/subscription";

export interface LoyaltyState {
  user: LoyaltyUser;
  tiers: LoyaltyTier[];
  complete: boolean;
  loading: boolean;
  error: boolean;
}

async function fetchUser() {
  const response = await axios.get<LoyaltyUser>("/loyalty-programme/user");
  return response.data;
}

async function fetchTiers() {
  const response = await axios.get<LoyaltyTier[]>("/loyalty-programme/tiers");
  return response.data;
}

export const useLoyalty = defineStore('loyaltyStore', {
  state: (): LoyaltyState => ({
    user: emptyLoyaltyUser(),
    tiers: [],
    complete: false,
    loading: false,
    error: false
  }),
  actions: {
    async fetch() {
      if (this.loading || this.complete) return;

      this.loading = true
      try {
        let [loyaltyUser, loyaltyTiers] = await Promise.all([
          fetchUser(),
          fetchTiers(),
        ]);

        this.$patch({
          user: loyaltyUser,
          tiers: loyaltyTiers,
          loading: false,
          complete: true
        })
      } catch (error) {
        this.$patch({
          loading: false,
          error: true
        })
      }
    },
    async editFavouriteReward(rewardId: number) {
      const response = await axios.put<LoyaltyUser>("/loyalty-programme/favourite-reward",
        {
          rewardId: rewardId
        });
      // this.user = response.data;
    }
  },
  getters: {
    isTierReached(state): ((tier: LoyaltyTier) => boolean) {
      return (tier: LoyaltyTier): boolean => state.user.runtime >= tier.runtimeToReach;
    },
    isUserFavourite(state): ((reward: LoyaltyReward) => boolean) {
      return (reward: LoyaltyReward): boolean => state.user.favouriteRewards.includes(reward.id)!
    },
    getUserTiers(): LoyaltyTier[] {
      return this.tiers!.filter(tier => this.user.runtime >= tier.runtimeToReach);
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLoyalty, import.meta.hot))
}
